(function($) {
    const windowHeight = () => {
        const doc = document.documentElement
        doc.style.setProperty('--window-height', `${window.innerHeight}px`);
    }
    
    windowHeight();
    window.addEventListener('resize', windowHeight);

    function getUrlParameter() {
        var strReturn = "";
        var strHref = window.location.href;
        
        if( strHref.indexOf("#") > -1 ) {
            strReturn = strHref.substr(strHref.indexOf("#")).toLowerCase();
            
        } else if( strHref.indexOf("?") > -1 ) {
            strReturn = strHref.substr(strHref.indexOf("?")).toLowerCase();
            
        }
        
        return (unescape(strReturn));
    }
    
    $(document).ready( function() {
        var windowWidth = $(window).width(),
            containerWidth = $('.footer .container').width(),
            edgeSpace = (windowWidth - containerWidth) / 2;

        var headerHeight = $('header.header').height();

        if( $('#shopify-section-announcement-bar').length ) {
            headerHeight = headerHeight + $('#shopify-section-announcement-bar').height();
        }
        
        var onResize = function() {
            windowWidth = $(window).width();
            containerWidth = $('.footer .container').width();
            edgeSpace = (windowWidth - containerWidth) / 2;

            headerHeight = $('header.header').height();
            
            if( $('#shopify-section-announcement-bar').length ) {
                headerHeight = headerHeight + $('#shopify-section-announcement-bar').height();
            }
            
            const doc = document.documentElement
            doc.style.setProperty('--header-height', `${headerHeight}px`);
        }
        
        onResize();

        $(window).resize( function() {
            onResize();
        });
        
        function siteInit() {
            $('#mega-menu').on('show.bs.offcanvas', function() {
                var _headerHeight = headerHeight;

                if( $('#shopify-section-header').hasClass('shopify-section-header-sticky') ) {
                    if( $('#shopify-section-announcement-bar').length ) {
                        _headerHeight = headerHeight - $('#shopify-section-announcement-bar').height();
                    }
                }

                $('#mega-menu').css({
                    paddingTop: _headerHeight + 'px'
                });
                
                $('header.header .toggle-menu').addClass('active');
            });

            $('#mega-menu').on('hide.bs.offcanvas', function() {
                $('header.header .toggle-menu').removeClass('active');
            });

            $('.mega-menu__nav .toggle').on('click', function(e) {
                $(this).toggleClass('active').siblings('ul.sub-menu').toggle();
            });
            
            $('header.header .toggle-search').on('click', function(e) {
                $('header.header .search').toggleClass('show');

                setTimeout( function() {
                    $('header.header .search input[name="keyword"]').focus();
                }, 300 );
            });
            
            $('.entry-content').fitVids();
            
            setTimeout( function() {
                var urlParameter = getUrlParameter();

                if( urlParameter == '?customer_posted=true' || urlParameter == '#newsletterfooter' || urlParameter == '#newslettermodal' ) {
                    if( urlParameter == '#newslettermodal' ) {
                        $('#newsletter-modal').modal('show');
                    
                        setTimeout( function() {
                            $('#newsletter-modal').modal('hide');
                        }, 2000);
                    } else {
                        $('html, body').animate({
                            scrollTop: $('#shopify-section-footer').offset().top
                        }, 300);
                    }
                } else if( $('.shopify-challenge__container').length ) {
                    $('html, body').animate({
                        scrollTop: 0
                    }, 300);
                }
            }, 2000);

            $('.search input[name="keyword"]').keyup( function(e) {
                var form = $(this).parents('form'),
                    value = $(this).val();
                    
                form.find('input[name="q"]').val('title:' + value + '*');
            });

            // $('#mega-menu').on('shown.bs.offcanvas', function() {
            //     console.log('Opened mega menu');

            //     $(document).off('.bs.focustrap');
            //     $(document).off('focusin.bs.focustrap');
            //     $(document).off('keydown.tab.bs.focustrap');
            // });
        }
        
        siteInit();

        function sWelcome() {
            $('.s-welcome__slider').on('init', function(event, slick) {
                var urlParameter = getUrlParameter();

                if( urlParameter == '?customer_posted=true' || urlParameter == '#newsletterfooter' ) {
                } else {
                    $('html, body').animate({
                        scrollTop: 0
                    }, 300);
                }
            });
            
            $('.s-welcome__slider').slick({
                dots: true,
                arrows: false,
                fade: true,
                autoplay: true,
                autoplaySpeed: 5000
            });
        }

        if( $('.s-welcome').length ) {
            sWelcome();
        }

        function sBanner() {
            var onResize = function() {
                $('.s-banner__text').css({
                    marginLeft: '-' + edgeSpace + 'px',
                    marginRight: '-' + edgeSpace + 'px',
                    paddingLeft: edgeSpace + 'px',
                    paddingRight: edgeSpace + 'px'
                });

                $('.s-banner__image').css({
                    marginLeft: '-' + edgeSpace + 'px',
                    marginRight: '-' + edgeSpace + 'px',
                    paddingLeft: edgeSpace + 'px',
                    paddingRight: edgeSpace + 'px'
                });
            }
            
            onResize();

            $(window).resize( function() {
                onResize();
            });
        }

        sBanner();

        function sCollectionList() {
            var onResize = function() {
                $('.s-collection-list .intro-image').css({
                    left: '-' + edgeSpace + 'px',
                    right: '-' + edgeSpace + 'px'
                });
            }
            
            onResize();

            $(window).resize( function() {
                onResize();
            });
        }

        sCollectionList();

        function sProducts() {
            $('.s-products').each( function() {
                var section = $(this),
                    slider = section.find('.s-products__slider');

                var firstTab = section.find('.s-products__heading .nav > li:first-child a[data-bs-toggle]');
                
                if( firstTab ) {
                    firstTab.tab('show');
                }
                
                if( slider.length ) {
                    var onResize = function() {
                        var cardImage = section.find('.card-product__image');

                        if( cardImage.length ) {
                            var cardImageHeight = cardImage.outerHeight();

                            section.css( '--card-image-height', cardImageHeight + 'px' );
                        }
                        
                        slider.css({
                            marginRight: '-' + edgeSpace + 'px'
                        });
                        
                        slider.find('.slick-dots').css({
                            marginRight: edgeSpace + 'px'
                        });
                    }
                    
                    $(window).resize( function() {
                        onResize();
                    });

                    slider.on('init', function( event, slick ) {
                        onResize();
                    });

                    slider.slick({
                        dots: true,
                        arrows: true,
                        autoplay: false,
                        variableWidth: true,
                        focusOnSelect: false,
                        infinite: true,
                        draggable: false
                    });
                }
            });
        }

        sProducts();

        function sAbout() {
            $('.s-about').each( function() {
                var section = $(this),
                    slider = section.find('.slider');

                if( slider.length ) {
                    var onResize = function() {
                        $('.s-about__gallery').css({
                            paddingLeft: edgeSpace + 'px'
                        });

                        slider.find('.slick-slide').css({
                            width: containerWidth + 'px'
                        });
                    }
                    
                    $(window).resize( function() {
                        onResize();
                    });
                    
                    slider.on('init', function( event, slick ) {
                        onResize();
                    });

                    slider.slick({
                        dots: false,
                        arrows: false,
                        autoplay: true,
                        autoplaySpeed: 5000,
                        variableWidth: true,
                        focusOnSelect: true,
                        infinite: true
                    });
                }
            });
        }

        sAbout();

        function templateProduct() {
            var slider = $('.product-gallery__slider'),
                thumbs = $('.product-gallery__thumbs img');
            
            slider.on('init', function(event, slick) {
                $('html, body').animate({
                    scrollTop: 0
                }, 300);
            });
            
            slider.slick({
                dots: false,
                arrows: false,
                autoplay: false,
                adaptiveHeight: true,
                accessibility: false,
                fade: true,
                speed: 600
            }).on('lazyLoaded', function(event, slick, image, imageSource) {
                slick.resize();
            });
            
            thumbs.on('click', function(e) {
                var index = $(this).parents('li').index();
                slider.slick( 'slickGoTo', index );
            });

            $('.product-tabs .nav > li > a').on('shown.bs.tab', function(event) {
                var target = $(event.target).attr('href');
                $(target).find('.collapse').collapse('show');
                $(target).fitVids();
            });
            
            var firstTab = $('.product-tabs .nav > li:first-child > a');
            
            if( firstTab ) {
                firstTab.tab('show');
            }
            
            $('.product-description a[href="#product-specifications"]').on('click', function(e) {
                $('.product-tabs a[href="#product-specifications"]').tab('show');

                $('html, body').animate({
                    scrollTop: $('#product-specifications').offset().top - 140
                }, 300);

                e.preventDefault();
            });
        }
        
        templateProduct();

        function announcementBar() {
            var status = sessionStorage.getItem('announcement_bar');
            
            if( status == 'close' ) {
                $('.announcement-bar').hide().remove();
            }
            
            $('.announcement-bar .close').on('click', function(e) {
                sessionStorage.setItem( 'announcement_bar', 'close' );
                $('.announcement-bar').fadeOut();

                e.preventDefault();
            });
        }

        if( $('.announcement-bar').length ) {
            announcementBar();
        }

        function newsletterModal() {
            var modal = $('#newsletter-modal'),
                status = sessionStorage.getItem('newsletter_modal'),
                urlParameter = getUrlParameter();

            modal.on('hidden.bs.modal', function(e) {
                sessionStorage.setItem( 'newsletter_modal', 'close' );
            });

            setTimeout( function() {
                if( urlParameter == '?customer_posted=true' || urlParameter == '#newslettermodal' ) {
                } else if( status !== 'close' ) {
                    modal.modal('show');
                }
            }, 30000);
        }
        
        if( $('#newsletter-modal').length ) {
            newsletterModal();
        }
    });
})(jQuery);